import React from "react";
import { useAppSelector } from "../../../redux/store";
import { useTranslation } from "react-i18next";

const FlightsTableBody = () => {
  const { t } = useTranslation();
  const booking = useAppSelector((state) => state.booking);
  const flights = booking.bookingFlights;

  return (
    <tbody>
      {flights.map((flight, i: any) => (
        <tr key={i}>
          <td>{flight.date}</td>
          <td>{flight.from}</td>
          <td>{flight.to}</td>
          <td>{flight.airline}</td>
          <td>{flight.flightNumber}</td>
          <td>{flight.departure}</td>
          <td>{flight.arrival}</td>
          <td>{flight.freeLuggage}</td>
        </tr>
      ))}
      <tr>
        <td colSpan={12} style={{ color: "darkorange" }}>
          {t("bookingDetails.flights.notice")}
        </td>
      </tr>
    </tbody>
  );
};

export default FlightsTableBody;
